import * as React from 'react';
import { memo, useCallback } from 'react';
import { Link } from 'react-router-dom';

import { keirinHelpUrl } from '@/lib/dmm/help';

import { LinkItem, LinkList, Overlay } from './style';

const links: {
  text: string;
  path: string;
}[] = [
  {
    text: '出走表一覧',
    path: '/racecard',
  },
  {
    text: 'レース結果一覧',
    path: '/results',
  },
  {
    text: '競輪場一覧',
    path: '/velodromes',
  },
  {
    text: '開催スケジュール',
    path: '/calendar',
  },
  {
    text: 'お知らせ一覧',
    path: '/news',
  },
  {
    text: 'DMM競輪 ご利用ガイド',
    path: '/guide',
  },
  {
    text: '競輪用語集',
    path: '/glossary',
  },
  {
    text: 'よくある質問',
    path: keirinHelpUrl,
  },
  {
    text: 'お問い合わせ',
    path: import.meta.env.VITE_DMM_INQUIRY_URL,
  },
];

const Menu: React.FC<{
  isActive: boolean;
  closeMenu: () => void;
}> = ({ isActive, closeMenu }) => {
  const isExternal = useCallback(
    (path: string) => !path.startsWith(import.meta.env.BASE_URL),
    [],
  );

  return (
    <Overlay isActive={isActive} onClick={() => closeMenu()} id="dropdown-menu">
      <LinkList isActive={isActive} onClick={e => e.stopPropagation()}>
        {links.map(link => (
          <LinkItem key={`link-item-${link.path}`} onClick={() => closeMenu()}>
            {isExternal(link.path) ? (
              <a href={link.path} target="_blank">
                {link.text}
              </a>
            ) : (
              <Link to={link.path}>{link.text}</Link>
            )}
          </LinkItem>
        ))}
      </LinkList>
    </Overlay>
  );
};

export default memo(Menu);
